// @ts-ignore
export const isCypressRunning = !!window.Cypress;
